import {Switch} from '@mantine/core';
import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useEditCityAvailability from 'modules/cities/hooks/use-edit-city-availability';
import React from 'react';
import Loading from 'shared/migration-components/loading';
import styled from 'styled-components';

const CityHeader: React.FC = () => {
  const editCityAvailability = useEditCityAvailability();
  const {accessControl, permissionGroup} = useAccessControls();

  return (
    <Container>
      <Letter>{accessControl?.city?.name[0]}</Letter>
      <Column>
        <Title>{accessControl?.city?.name}</Title>
        <Description>{permissionGroup?.name}</Description>
      </Column>
      {!editCityAvailability.isLoading && (
        <Switch
          size="md"
          checked={accessControl?.city?.available}
          onChange={() => editCityAvailability.mutate(undefined)}
        />
      )}
      {editCityAvailability.isLoading && <Loading flex={false} />}
    </Container>
  );
};

export default CityHeader;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
`;

const Column = styled.div`
  color: ${(props) => props.theme.colors.text};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h3`
  line-height: 1;
  font-size: 12px;
`;

const Description = styled.span`
  font-size: 11px;
`;

const Letter = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(128, 128, 128, 0.4);
`;
